export default __webpack_public_path__ + "static/media/WormViz_1.12400d9b.png";